<template>
  <div>
    <!-- 表單模式 -->
    <div v-if="showForm">
      <div class="page-header custom-container">
        <span>重置盤</span>
      </div>
      <div class="member custom-container-xl">
        <div class="member__box">
          <div class="personal__info">
            <!-- 出生日期 -->
            <div class="personal__item">
              <span class="item__title">出生日期</span>
              <div class="item__input" @click.stop="dateModal = true">
                <span>{{ birthDate }}</span>
                <v-dialog
                  ref="dialogDate"
                  v-model="dateModal"
                  :return-value.sync="birthDate"
                  width="290px"
                  persistent
                >
                  <v-date-picker
                    class="picker date-picker"
                    v-model="birthDate"
                    :first-day-of-week="0"
                    locale="zh-cn"
                    scrollable
                    header-color="rgba(217, 217, 217, 0.25)"
                    color="primary"
                    max="2099-12-31"
                    min="0676-01-01"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="dateModal = false">取消</v-btn>
                    <v-btn text color="error" @click="$refs.dialogDate.save(birthDate)">確認</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </div>

            <!-- 出生時間 -->
            <div class="personal__item">
              <span class="item__title">出生時間</span>
              <div class="time-wrap">
                <div class="item__input" @click.stop="timeModal = true">
                  <span>{{ birthTime }}</span>
                  <v-dialog
                    ref="dialogTime"
                    v-model="timeModal"
                    :return-value.sync="birthTime"
                    width="290px"
                    persistent
                  >
                    <v-time-picker
                      class="picker time-picker"
                      v-model="birthTime"
                      v-if="timeModal"
                      scrollable
                      ampm-in-title
                      header-color="rgba(217, 217, 217, 0.25)"
                      color="primary"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="timeModal = false">取消</v-btn>
                      <v-btn text color="error" @click="$refs.dialogTime.save(birthTime)">確認</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </div>
                <label class="checkbox-wrap">
                  我不知道
                  <input type="checkbox" v-model="IDontKnow" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>

            <!-- 日光節約時間 -->
            <div class="personal__item">
              <span class="item__title">
                日光節約時間
                <img src="@/assets/日光節約icon.svg" />
              </span>
              <div class="item__sex">
                <div
                  class="sex-box male"
                  :class="{ activeSex: IsDaylight }"
                  @click="IsDaylight = true"
                >是</div>
                <div
                  class="sex-box female"
                  :class="{ activeSex: !IsDaylight }"
                  @click="IsDaylight = false"
                >否</div>
              </div>
            </div>

            <!-- 出生地點 -->
            <div class="personal__item">
              <span class="item__title">出生地點</span>
              <div class="item__input">
                <v-autocomplete
                  class="select"
                  :items="cityList"
                  v-model="birthCity"
                  label="請選擇或輸入出生地點"
                  background-color="transparent"
                  solo
                  hide-details
                ></v-autocomplete>
              </div>
            </div>

            <!-- 欲前往的城市 -->
            <div class="personal__item">
              <span class="item__title">欲前往的城市</span>
              <div class="item__input">
                <v-autocomplete
                  class="select"
                  :items="cityList"
                  v-model="destinationCity"
                  label="請選擇或輸入目標城市"
                  background-color="transparent"
                  solo
                  hide-details
                ></v-autocomplete>
              </div>
            </div>
          </div>

          <!-- 計算按鈕 -->
          <div class="personal__btns">
            <div
              class="personal__save"
              :class="{ notReady: !formReady }"
              @click="calculate"
            >計算</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 結果模式 -->
    <div class="row-wrap custom-container" v-else>
      <div class="params_box" v-if="TcAstralInfo">
        <div class="personal__btns back-area">
          <div class="personal__cancel" @click="backToForm">返回設定</div>
        </div>
        <!-- 重置盤資訊卡 -->
        <div class="relocation-info">
          <div class="relocation-info__item">
            <span class="relocation-info__label">出生年月日</span>
            <span class="relocation-info__value">{{ formattedBirthDateTime }}</span>
          </div>
          <div class="relocation-info__item">
            <span class="relocation-info__label">出生地</span>
            <span class="relocation-info__value">{{ birthCity }}</span>
          </div>
          <div class="relocation-info__item">
            <span class="relocation-info__label">欲前往的城市</span>
            <span class="relocation-info__value">
              {{ destinationCity }}
              <span class="relocation-info__coords" v-if="destinationLat && destinationLng">
                （{{ destinationLat }}, {{ destinationLng }}）
              </span>
            </span>
          </div>
        </div>
        <Params
          :TcAstralInfo="TcAstralInfo"
          :AstrolabeType="'C2'"
          :role="role"
          :moondayObj="moondayObj"
        ></Params>
      </div>
      <NewAstrolabe
        v-if="TcAstralInfo"
        :data1="TcAstralInfo.AstralRadians"
        :data2="null"
        :type="0"
        :styleArray="styleArray"
        :role="role"
        :Ret1="TcAstralInfo.RetAstralSet"
        :showNowTime="false"
        :format_time="formattedBirthDateTime"
        mode="astrometryMode"
        :nowTimeNowPlaceBtn="false"
        :nowTimeNowPlaceIng="false"
        :nowPlace="destinationPlaceDisplay"
        :moondayObj="moondayObj"
        :hiddenuserDesktopInfo="true"
      ></NewAstrolabe>
    </div>
  </div>
</template>

<script>
import NewAstrolabe from "@/components/星盤組件/new_astrolabe";
import Params from "@/components/星盤組件/Params_astrometry.vue";
import cityCoordinates from "@/js/cityCoordinates.js";
import tzlookup from "tz-lookup";
import { getTzOffset } from "@/js/tzUtils.js";

const LS_KEY = "relocation_form";

export default {
  components: {
    NewAstrolabe,
    Params,
  },
  data() {
    return {
      showForm: true,
      TcAstralInfo: null,
      role: "Relocation",
      // 表單資料
      birthDate: "1990-01-01",
      birthTime: "12:00",
      birthCity: null,
      destinationCity: null,
      IsDaylight: false,
      IDontKnow: false,
      // 彈窗開關
      dateModal: false,
      timeModal: false,
      // 星盤相關
      styleArray: [
        { name: "文字", displayName: "文字", show: false, id: "alert1" },
        { name: "JOE2", displayName: "專業", show: false, id: "alert5" },
      ],
      moondayObj: {},
    };
  },
  computed: {
    cityList() {
      return Object.keys(cityCoordinates);
    },
    formReady() {
      return this.birthDate && this.birthTime && this.birthCity && this.destinationCity;
    },
    formattedBirthDateTime() {
      if (!this.birthDate || !this.birthTime) return "";
      // birthDate: "1990-01-01" → "1990/01/01"
      const date = this.birthDate.replace(/-/g, "/");
      return `${date} ${this.birthTime}`;
    },
    destinationCoords() {
      if (!this.destinationCity) return null;
      return cityCoordinates[this.destinationCity] || null;
    },
    destinationLat() {
      if (!this.destinationCoords) return null;
      const lat = this.destinationCoords.lat;
      return lat >= 0
        ? parseFloat(lat).toFixed(2) + "N"
        : parseFloat(lat).toFixed(2) + "S";
    },
    destinationLng() {
      if (!this.destinationCoords) return null;
      const lng = this.destinationCoords.lng;
      return lng >= 0
        ? parseFloat(lng).toFixed(2) + "E"
        : parseFloat(lng).toFixed(2) + "W";
    },
    destinationPlaceDisplay() {
      return this.destinationLng && this.destinationLat
        ? `${this.destinationLng}, ${this.destinationLat}`
        : "";
    },
    // 目的地的真實法定時區
    destinationTz() {
      const coords = this.destinationCoords;
      if (!coords) return 8;
      try {
        const tzName = tzlookup(parseFloat(coords.lat), parseFloat(coords.lng));
        return getTzOffset(tzName);
      } catch (_) { return 8; }
    },
    Arg() {
      if (!this.destinationCoords) return null;
      return {
        AstrolabeType: "SC",
        BirthTime: this.formattedBirthDateTime,
        IsDaylight: this.IsDaylight,
        BirthLocation: {
          TimeZone: this.destinationTz,
          Latitude: this.destinationLat,
          Longitude: this.destinationLng,
        },
      };
    },
  },
  watch: {
    IDontKnow(val) {
      if (val) {
        this.birthTime = "12:00";
      }
    },
  },
  created() {
    this.loadFromStorage();
    this.applyQueryParams();
  },
  methods: {
    loadFromStorage() {
      try {
        const saved = window.localStorage.getItem(LS_KEY);
        if (!saved) return;
        const data = JSON.parse(saved);
        this.birthDate = data.birthDate || this.birthDate;
        this.birthTime = data.birthTime || this.birthTime;
        this.birthCity = data.birthCity || null;
        this.destinationCity = data.destinationCity || null;
        this.IsDaylight = data.IsDaylight || false;
        this.IDontKnow = data.IDontKnow || false;
        // 若上次有計算結果，直接恢復結果模式
        if (data.TcAstralInfo) {
          this.TcAstralInfo = data.TcAstralInfo;
          this.showForm = false;
        }
      } catch (e) {
        // ignore
      }
    },
    // 接收從 ACG 幸運地圖跳轉過來的 query 參數
    applyQueryParams() {
      const q = this.$route.query;
      if (!q || !q.destLat) return;
      // 有 ACG 帶來的參數，覆蓋表單並直接顯示表單（讓使用者確認後再按計算）
      if (q.birthDate) this.birthDate = q.birthDate;
      if (q.birthTime) this.birthTime = q.birthTime;
      if (q.isDaylight !== undefined) this.IsDaylight = q.isDaylight === "1";
      if (q.destCity) this.destinationCity = q.destCity;
      // 若城市清單中沒有精確對應，仍保留 ACG 地圖點選的城市名
      this.showForm = true;
      this.TcAstralInfo = null;
    },
    saveToStorage(TcAstralInfo) {
      const data = {
        birthDate: this.birthDate,
        birthTime: this.birthTime,
        birthCity: this.birthCity,
        destinationCity: this.destinationCity,
        IsDaylight: this.IsDaylight,
        IDontKnow: this.IDontKnow,
        TcAstralInfo: TcAstralInfo || null,
      };
      window.localStorage.setItem(LS_KEY, JSON.stringify(data));
    },
    calculate() {
      if (!this.formReady) {
        alert("請填寫完整的出生日期、時間、出生地點及目標城市");
        return;
      }
      if (!this.Arg) return;
      this.$store.commit("setLoading_force", true);
      console.log("Request Arg:", this.Arg);
      this.$API.POST_TcAstralInfo(this.Arg).then((res) => {
        this.$store.commit("setLoading_force", false);
        if (res && res.Data && res.Data.Result) {
          this.TcAstralInfo = res.Data.AstralInfo;
          this.saveToStorage(this.TcAstralInfo);
          this.showForm = false;
        } else {
          alert("計算失敗，請確認輸入資料後重試");
        }
      }).catch(() => {
        this.$store.commit("setLoading_force", false);
        alert("計算失敗，請稍後再試");
      });
    },
    backToForm() {
      this.showForm = true;
      // 清除 localStorage 中的結果，保留表單資料
      this.saveToStorage(null);
    },
    // IANA 時區名稱 → UTC 偏移小時（已移至 src/js/tzUtils.js 統一維護）
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/header.scss";
@import "@/scss/userFile.scss";
@import "@/scss/editFile.scss";

// ── 表單：計算按鈕全寬 ──
.personal__btns {
  .personal__save {
    width: 100%;
  }
}

// ── 結果模式：返回按鈕區塊靠左 ──
.personal__btns.back-area {
  justify-content: flex-start;
  margin-top: 0;
  margin-bottom: 12px;
  .personal__cancel {
    width: auto;
    padding: 0 24px;
  }
}

// ── 結果模式：左右兩欄版面 ──
.row-wrap {
  @include align(space-around, flex-start);
  margin: 36px auto;

  @include laptop {
    flex-direction: column;
    @include center;
    .params_box {
      order: 2;
    }
  }

  @include pad {
    margin: 0 auto;
    padding: 0;
  }
}

// ── 左側參數欄 ──
.params_box {
  width: 44%;
  @include align(flex-start, center);
  flex-direction: column;
  margin-right: 30px;

  @include laptop {
    margin-right: 0;
    margin-top: 16px;
    width: 70%;
  }

  @include pad {
    width: 100%;
    padding: 0 16px;
    margin-top: 12px;
  }

  @include mobile {
    padding: 0 12px;
  }
}

// ── 重置盤資訊卡 ──
.relocation-info {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;

  &__item {
    @include align(flex-start, baseline);
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }

    @include mobile {
      flex-direction: column;
      margin-bottom: 12px;
    }
  }

  &__label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    white-space: nowrap;
    min-width: 110px;
    margin-right: 8px;

    @include mobile {
      font-size: 11px;
      min-width: unset;
      margin-bottom: 2px;
    }
  }

  &__value {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    flex: 1;

    @include mobile {
      font-size: 13px;
    }
  }

  &__coords {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;

    @include mobile {
      display: block;
      font-size: 11px;
      margin-top: 2px;
    }
  }

  @include pad {
    border-radius: 8px;
    padding: 14px 16px;
  }

  @include mobile {
    padding: 12px 14px;
    margin-bottom: 12px;
  }
}
</style>
